import { Box, Grid, LinearProgress, Skeleton, Typography } from "@mui/material";
import { bytesConverter } from "../MemoryProgress/bytesConverter";
import { useTranslation } from "react-i18next";
import { StorageSizeInfoModel } from "../../../../../model/StorageSizeInfoModel";

export interface IDashboardCardGeneral {
  loading?: boolean;
  data?: StorageSizeInfoModel;
}

const styles = {
    title: {
      font: "normal normal 600 16px/21px Segoe UI",
      letterSpacing: "0px",
      color: "#2D2D2D",
    },
    subtitle: {
      font: "normal normal normal 12px/18px Segoe UI",
      letterSpacing: "0px",
      color: "#969696",
    },
    storageValue: {
      font: "normal normal 600 14px/21px Segoe UI",
      letterSpacing: "0px",
      color: "#2D2D2D",
      display: "inline",
    },
    storageText: {
      font: "normal normal normal 14px/21px Segoe UI",
      letterSpacing: "0px",
      color: "#2D2D2D",
      display: "inline",
    },
    noDataText: {
      font: "normal normal 500 14px/21px Segoe UI",
      color: "#2D2D2D",
      textAlign: "center",
    }
  };
  
export const DashboardCardGeneral = ({
  loading = false,
  data = { totalSpace: 0, usedSpace: 0, freeSpace: 0 }
}: IDashboardCardGeneral) => {
  const { t } = useTranslation();
  const hasData = data?.usedSpace >= 0;

  const getProgressPercentage = (used: number, total: number) => {
    var value = (used / total) * 100; 
    return value > 100 ? 100 : value;
  };
  
  return (
    <Box sx={{ position: "relative", width: "100%"}}>
      <Box sx={{
        filter: hasData ? "none" : "blur(3px)",
        transition: "filter 0.3s ease",
      }}>
        <Box
          sx={{ margin: "0 0 12px 0" }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {loading ? (
            <>
              <Skeleton width={60} height={20} />
              <Skeleton width={180} height={18} />
            </>
          ) : (
            <>
              <Typography sx={styles.title}>
                {t("Dashboard.general")}
              </Typography>
              <Typography sx={styles.subtitle}>
                {t("Dashboard.storageLimit")} {bytesConverter(data.totalSpace)}
              </Typography>
            </>
          )}
        </Box>

        {loading ? (
          <Skeleton variant="rectangular" height={8} sx={{ borderRadius: "2px" }} />
        ) : (
          <LinearProgress
            variant="determinate"
            value={getProgressPercentage(data.usedSpace, data.totalSpace)}
            sx={{
              height: "8px",
              borderRadius: "2px",
              flex: 1,
              backgroundColor: "#E9EFF4",
              "& .MuiLinearProgress-bar": {
                backgroundColor: "#22638D",
                borderRadius: "2px 0px 0px 2px",
              },
            }}
          />
        )}

        <Box
          sx={{ margin: "8px 0 12px 0" }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {loading ? (
            <>
              <Skeleton width={120} height={20} />
              <Skeleton width={120} height={20} />
            </>
          ) : (
            <>
              <Box>
                <Typography sx={styles.storageValue}>
                  {bytesConverter(data.usedSpace, 2)}{" "}
                </Typography>
                <Typography sx={styles.storageText}>
                  {t("Dashboard.storageInUse")}
                </Typography>
              </Box>
              <Box>
                <Typography sx={styles.storageText}>
                  {t("Dashboard.freeStorage")}
                </Typography>
                <Typography sx={styles.storageValue}>
                  {" "}
                  {bytesConverter(data.freeSpace, 2)}
                </Typography>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {!hasData && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100px",
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px",
          }}
        >
          <Typography sx={styles.noDataText}>
            {t("Dashboard.notFoundgeneralData")}
          </Typography>
        </Box>
      )}
    </Box>
  )
}